<template>
  <!-- 如果是uid登录显示要令牌登录的提示 -->
  <p class="coins-payment-token" v-if="isUidLogin">
    {{ tokenLoginTip }}
  </p>
  <div class="coins-payment" v-else>
    <p class="coins-payment-balance">
      <span class="name">{{ getCoinsName }}&nbsp</span>
      <span class="balance">{{ letter.remain }}&nbsp</span>
      <span class="number">{{ amount }}&nbsp</span>
      <span class="currency">{{ currency }}&nbsp</span>
      <a
        href="javascript:;"
        class="refresh-balance iconfont icon-switch"
        :class="{ ani: boolPlayRefreshAni }"
        @click="refreshUserBalance"
      ></a>
    </p>
    <p class="coins-payment-result" v-if="boolEnoughBalance">
      <span class="balance">{{ payRemainExpiry }}</span>
      <!-- <span class="number">{{ payAfterAmount }}</span>
      <span class="currency">{{ currency }}</span> -->
    </p>
    <div class="coins-payment-pay" v-else>
      <p class="tip">{{letter.balanceNotEnoughExpiry}}</p>
    </div>
  </div>
</template>

<script>
import {
  GET_BALANCE_ONE_USER_DATA,
  GET_BALANCE_INIT_DATA,
  GET_BALANCE_USER_DATA,
  UPDATE_BOOL_ENOUGH_BALANCE,
  UPDATE_COIN,
  getCurrencyByArea
} from '@store/officialWebStore/coins';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'CoinsPayment',
  props: ['curLocationVal', 'curCoins', 'curPayType', 'discountTransMount'],
  data() {
    return {
      amount: 0,
      currency: '',
      boolEnoughBalance: true,
      payAfterAmount: 0,
      boolPlayRefreshAni: false,
      balanceRefreshThrottle: {
        canRefresh: true,
        timer: null
      },
      balanceItem: null
    };
  },
  watch: {
    curCoins: {
      immediate: true,
      handler() {
        this.loadUserBalance();
      }
    },
    paytypeActiveCouponId() {
      this.hasCoinsPayAfterAmount();
    },
    isUidTokenLogin(newVal) {
      // 令牌登录成功后需要刷新一下代币余额
      newVal && this.refreshUserBalance();
    }
  },
  computed: {
    ...mapState({
      isUidLogin: state => state.login.isUidLogin,
      isUidTokenLogin: state => state.login.isUidTokenLogin,
      gameId: state => state.gameId,
      letter: state => state.letter,
      paytypeActiveCouponId: state => state.coupon.paytypeActiveCouponId
    }),
    ...mapGetters(['getCoinsName', 'isJpPlatform']),
    tokenLoginTip() {
      return this.letter.coinsPayTokenLogin.replace(
        '${Z-BIT}',
        this.getCoinsName
      );
    },
    payRemainExpiry() {
      return this.letter.payRemainExpiry.replace('${money}',`${this.payAfterAmount}${this.currency}`);
    }
  },
  methods: {
    async refreshUserBalance() {
      if (!this.balanceRefreshThrottle.canRefresh) {
        return;
      }
      this.balanceRefreshThrottle.canRefresh = false;
      clearTimeout(this.boolEnoughBalance.timer);
      this.playRefreshAni();
      await this.loadUserBalance();
      this.balanceRefreshThrottle.timer = setTimeout(() => {
        this.stropRefreshAni();
        this.balanceRefreshThrottle.canRefresh = true;
      }, 1000);
    },
    async loadUserBalance() {
      const { res } = await this.$store.dispatch(
        GET_BALANCE_ONE_USER_DATA,
        this.curLocationVal
      );
      if (
        parseInt(res.result) === 1 &&
        /Array/i.test(res.data.balanceList.constructor.toString()) &&
        res.data.balanceList.length >= 1
      ) {
        const curLocationCurrency = getCurrencyByArea(this.curLocationVal);
        this.balanceItem = res.data.balanceList.find(item => {
          return item?.currency === curLocationCurrency;
        });
        this.balanceItem && this.hasCoinsPayAfterAmount();
        return Promise.resolve();
      }
      this.noCoinsPayAfterAmount();
      return Promise.resolve();
    },
    async goToPayCoin() {
      await this.$store.dispatch(GET_BALANCE_INIT_DATA, {
        location: this.curLocationVal
      });
      await this.$store.dispatch(GET_BALANCE_USER_DATA);
      this.$router.push({ name: 'coins' });
    },
    noCoinsPayAfterAmount() {
      // 没有这个代币
      this.amount = 0;
      this.currency = getCurrencyByArea(this?.curLocationVal);
      this.payAfterAmount = 0 - this.curCoins?.TRANS_AMOUNT;
      this.boolEnoughBalance = this?.payAfterAmount >= 0;
      this.$store.commit(UPDATE_BOOL_ENOUGH_BALANCE, {
        boolEnoughBalance: this?.boolEnoughBalance,
        payAfterAmount: this?.payAfterAmount,
        payAfterCurrency: this?.currency
      });
      this.$store.commit(UPDATE_COIN, {
        amount: this?.amount,
        currency: this?.currency
      });
    },
    hasCoinsPayAfterAmount() {
      if (!this.balanceItem) {
        this.noCoinsPayAfterAmount();
        return;
      }
      // 有这个代币
      this.amount = this.balanceItem?.amount;
      this.currency = this.balanceItem?.currency;
      // 不使用购物车
      if (this.paytypeActiveCouponId !== '') {
        // 使用优惠券
        this.payAfterAmount = (
          this.balanceItem?.amount - this.discountTransMount
        ).toFixed(2);
      } else {
        // 不使用优惠券
        this.payAfterAmount = (
          this.balanceItem?.amount - this.curCoins?.TRANS_AMOUNT
        ).toFixed(2);
      }
      this.boolEnoughBalance = this.payAfterAmount >= 0;
      this.$store.commit(UPDATE_BOOL_ENOUGH_BALANCE, {
        boolEnoughBalance: this.boolEnoughBalance,
        payAfterAmount: this.payAfterAmount,
        payAfterCurrency: this?.currency
      });
      this.$store.commit(UPDATE_COIN, this.balanceItem);
    },
    playRefreshAni() {
      this.boolPlayRefreshAni = true;
    },
    stropRefreshAni() {
      this.boolPlayRefreshAni = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.coins-payment-token {
  display: block;
  margin-bottom: 20px;
  width: 100%;
  padding: 32px 0 0 120px;
}

.coins-payment {
  display: block;
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  padding: 32px 0 0 120px;
  cursor: auto;
  &-balance {
    margin-bottom: 26px;
    color: #333;
    > span {
      font-size: 24px;
    }
    .number {
      display: inline-block;
      font-size: 30px;
      color: $btnBg;
    }
  }
  &-result {
    font-size: 24px;
    .balance,
    .number {
      margin-right: 8px;
    }
  }
  &-pay {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .refresh-balance {
    display: inline-block;
    margin-left: 8px;
    font-size: 24px;
    &.ani {
      animation: rotate 1.5s infinite linear;
    }
  }
}
@media screen and (orientation: landscape) {
  .coins-payment-balance {
    font-size: 22px;
    > span {
      font-size: 22px;
    }
    .number {
      font-size: 24px;
    }
  }
  .coins-payment-result {
    font-size: 22px;
  }
}
</style>
